<template>
  <b-modal
    :title="`Detalles del Documento ${file.id}`"
    v-model="showModal"
    no-close-on-backdrop
    centered
    hide-footer
    content-class="fullscreen"
    size="xl"
    scrollable
  >
    <vs-progress
      class="mb-1"
      v-if="loading"
      indeterminate
      color="primary"
    />
    <div class="row">
      <div class="col-6">
        <div class="card">
          <div class="card-header">
            <h4>Datos del documento</h4>
          </div>
          <div class="card-body">
            <b-badge
              variant="light-info"
              class="text-wrap mb-4"
              v-tooltip="'Folio'"
            >
              <feather-icon icon="CodeIcon" />
              {{ file.folio }}
            </b-badge>
            <b-badge
              variant="light-info"
              class="text-wrap ml-2 mb-4"
              v-tooltip="'Fecha de creación'"
            >
              <feather-icon icon="CalendarIcon" />
              {{ file.createdAt }}
            </b-badge>
            <b-badge
              variant="light-info"
              class="text-wrap ml-2 mb-4"
              v-tooltip="'Tipo'"
            >
              <feather-icon icon="InfoIcon" />
              {{ file.typeDescription }}
            </b-badge>
            <h6>Materia</h6>
            <p>{{ file.theme }}</p>
            <h6>Descripción</h6>
            <p>{{ file.description }}</p>
            <div class="float-right" @click="getFile(file.url)">
              <a class="btn btn-icon btn-primary btn-sm">
                <feather-icon icon="DownloadIcon" />
              </a>
            </div>
            <div class="clearfix" />

          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <h4>Archivos Anexos</h4>
          </div>
          <div class="card-body">
            <p v-if="!file.relatedDocuments.length">
              No tiene archivos anexos
            </p>
            <a
              v-for="relatedFile in file.relatedDocuments"
              class="btn btn-outline-secondary btn-sm mr-1 mb-1"
              :key="relatedFile.if"
              @click="getFile(relatedFile.url, relatedFile.name)"
            >
              {{ relatedFile.name }}
              <feather-icon icon="DownloadIcon" />
            </a>
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <h4>Destinatarios</h4>
          </div>
          <div class="card-body">
            <vs-table stripe :data="(file.targetUsers || [])">
              <template slot="header">
              </template>
              <template slot="thead">
                <vs-th>
                  Nombre
                </vs-th>
                <vs-th>
                  Estado
                </vs-th>
                <vs-th>
                  Motivo
                </vs-th>
              </template>
              <template>
                <tbody>
                  <vs-tr
                    v-for="user in (file.targetUsers || [])"
                    :key="user.usuarioId"
                  >
                    <vs-td>
                      {{user.usuarioNombre}}
                    </vs-td>
                    <vs-td>
                      <vs-chip
                        title="Recibido"
                        v-if="user.estadoProceso === 'RECIBIDO'"
                        data-cy="received"
                      >
                        <vs-avatar icon="thumb_up" color="#28c76f" />
                        Recibido
                      </vs-chip>
                      <vs-chip
                        title="Pendiente"
                        v-if="user.estadoProceso === 'PENDIENTE'"
                        data-cy="pending"
                      >
                        <vs-avatar icon="warning" color="#ff9f43" />
                        Pendiente
                      </vs-chip>
                      <vs-chip
                        title="Rechazado"
                        v-if="user.estadoProceso === 'RECHAZADO'"
                        data-cy="rejected"
                      >
                        <vs-avatar icon="thumb_down" color="#ea5455" />
                        Rechazado
                      </vs-chip>
                      <vs-chip
                        :title="user.estadoProceso"
                        v-if="!['RECHAZADO','PENDIENTE','RECIBIDO'].includes(user.estadoProceso)"
                        :data-cy="'copy-state-'+user.estadoProceso"
                      >
                        {{ user.estadoProceso }}
                      </vs-chip>
                    </vs-td>
                    <vs-td>
                      {{ user.estadoProceso === 'RECHAZADO' ? user.estadoMotivo : '-' }}
                    </vs-td>
                  </vs-tr>
                </tbody>
              </template>
            </vs-table>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="card">
          <div class="card-header">
            <h4>Datos del creador</h4>
          </div>
          <div class="card-body">
            <h6>Correo</h6>
            <p>{{ file.creatorEmail }}</p>
            <h6>Nombre</h6>
            <p>{{ file.creatorName }}</p>
            <h6>Entidad</h6>
            <p>{{ file.creatorEntityName }}</p>
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <h4>Firmado por:</h4>
          </div>
          <div class="card-body">
            <p v-if="!file.signers.length">
              No tiene firmantes
            </p>
            <b-media
              no-body
              v-for="user in file.signers"
              :key="user.id"
              class="mb-2"
            >
              <b-media-aside class="mr-75">
                <b-avatar
                  rounded
                  size="36"
                />
              </b-media-aside>
              <b-media-body class="my-auto">
                <h6 class="mb-0">
                  {{ user.name }}
                </h6>
                <small>{{ user.entityName }}</small>
              </b-media-body>
            </b-media>
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <h4>Visadores:</h4>
          </div>
          <div class="card-body">
            <p v-if="!file.certifiers.length">
              No tiene visadores
            </p>
            <b-media
              no-body
              v-for="user in file.certifiers"
              :key="user.id"
              class="mb-2"
            >
              <b-media-aside class="mr-75">
                <b-avatar
                  rounded
                  size="36"
                />
              </b-media-aside>
              <b-media-body class="my-auto">
                <h6 class="mb-0">
                  {{ user.name }}
                </h6>
                <small>{{ user.entityName }}</small>
              </b-media-body>
            </b-media>
          </div>
        </div>
        <div class="card" v-if="!!withCopyEntity.length">
          <div class="card-header">
            <h4>Con copia a</h4>
          </div>
          <div class="card-body">
            <vs-table stripe :data="(withCopyEntity || [])">
              <template slot="header">
              </template>
              <template slot="thead">
                <vs-th>
                  Nombre
                </vs-th>
                <vs-th>
                  Estado
                </vs-th>
                <vs-th>
                  Motivo
                </vs-th>
              </template>
              <template>
                <tbody>
                <vs-tr
                  v-for="entity in (withCopyEntity || [])"
                  :key="entity.entidadId"
                >
                  <vs-td>
                    {{entity.entidadNombre}}
                  </vs-td>
                  <vs-td>
                    <vs-chip
                      title="Recibido"
                      v-if="entity.estado === 'RECIBIDO'"
                      data-cy="received"
                    >
                      <vs-avatar icon="thumb_up" color="#28c76f" />
                      Recibido
                    </vs-chip>
                    <vs-chip
                      title="Pendiente"
                      v-if="entity.estado === 'PENDIENTE'"
                      data-cy="pending"
                    >
                      <vs-avatar icon="warning" color="#ff9f43" />
                      Pendiente
                    </vs-chip>
                    <vs-chip
                      title="Rechazado"
                      v-if="entity.estado === 'RECHAZADO'"
                      data-cy="rejected"
                    >
                      <vs-avatar icon="thumb_down" color="#ea5455" />
                      Rechazado
                    </vs-chip>
                    <vs-chip
                      :title="entity.estado"
                      v-if="!['RECHAZADO','PENDIENTE','RECIBIDO'].includes(entity.estado)"
                      :data-cy="'copy-state-'+entity.estado"
                    >
                      {{ entity.estado }}
                    </vs-chip>
                  </vs-td>
                  <vs-td>
                    {{ entity.estado === 'RECHAZADO' ? entity.motivo : '-' }}
                  </vs-td>
                </vs-tr>
                </tbody>
              </template>
            </vs-table>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>

import { mapActions } from 'vuex';

import FindTypeDocumentMixin from '@/febos/chile/dnt/mixins/FindTypeDocumentMixin';
import ModalHandlerMixin from '@/febos/global/_vue/mixins/ModalHandlerMixin';

export default {
  name: 'PopUpGeneralDetailFile',
  data() {
    return {
      loading: false
    };
  },
  mixins: [FindTypeDocumentMixin, ModalHandlerMixin],
  props: {
    file: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  methods: {
    ...mapActions('docDigital', ['getDocDigitalFiles']),
    async getFile(url, name) {
      if (this.loading) return;
      this.loading = true;
      const response = await this.getDocDigitalFiles({
        params: {
          metodo: 'get_file'
        },
        url,
        name: name || 'archivo_principal.pdf'
      });
      this.loading = false;
      window.open(response.url, '_blank');
    }
  },
  computed: {
    withCopyEntity() {
      const entitiesMap = this.file.withCopy.entidades.map((item) => [item.entidadId, item]);
      const entitiesMapArr = new Map(entitiesMap);

      return [...entitiesMapArr.values()];
    }
  }
};
</script>
<style>
  .fullscreen {
    height: 90vh !important;
  }
  .tooltip {
    /* TODO: remove this when the vuexy integration is ready*/
    z-index: 53001;
  }
</style>

<style scoped>
.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 10px 15px;
  background: rgba(var(--vs-primary), 1) !important;
  color: white !important;
}
</style>
